import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import moment from 'moment';
import Calendar from 'icons/calendar';
import Button from 'components/buttons/Button';
import Menu from 'components/Menu/Menu';
import MenuItem from 'components/Menu/MenuItem';
import DateRangePicker, { ANCHOR_LEFT } from 'components/forms/DateRangePicker';
import { getFilterStyle } from 'styles/const';
import { DATE_FORMAT_SLASHES } from 'constants/config';


export const LAST_WEEK_DATE_OPTION = { label: 'Last 7 days', value: 'weeks' };
export const LAST_MONTH_DATE_OPTION = { label: 'Last 30 days', value: 'months' };
export const LAST_YEAR_DATE_OPTION = { label: 'Last 365 days', value: 'years' };
export const CUSTOM_DATE_OPTION = { label: 'Custom', value: 'custom_date_range' };

const DATE_OPTIONS = [
  LAST_WEEK_DATE_OPTION,
  LAST_MONTH_DATE_OPTION,
  LAST_YEAR_DATE_OPTION,
  CUSTOM_DATE_OPTION,
];


const DateTimeWithRangeFilter = ({ value, onChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenuClick = e => e.preventDefault() || setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const [filterParams, setFilterParams] = useState(value);

  const [showDatePicker, setShowDatePicker] = useState(false);

  const handleOnCloseDateRange = ({ startDate, endDate }) => {
    if (!startDate || !endDate) {
      setShowDatePicker(false);
    }
  };
  const handleDateChange = (startDate, endDate) => {
    if (startDate && endDate) {
      setFilterParams({
        ...filterParams,
        startDate,
        endDate,
      });
      setFilterParams((prevState) => {
        setShowDatePicker(!showDatePicker);
        onChange(prevState);
        return prevState;
      });
    }
  };

  const handleDateChangeFilter = (dateSelector) => {
    handleMenuClose();
    let { startDate, endDate } = filterParams;
    switch (dateSelector) {
      case LAST_WEEK_DATE_OPTION:
        startDate = moment().subtract(7, 'd').local();
        endDate = moment().local();
        break;
      case LAST_MONTH_DATE_OPTION:
        startDate = moment().subtract(1, 'months').local();
        endDate = moment().local();
        break;
      case LAST_YEAR_DATE_OPTION:
        startDate = moment().subtract(1, 'y').local();
        endDate = moment().local();
        break;
      case CUSTOM_DATE_OPTION:
        setShowDatePicker(!showDatePicker);
        setFilterParams({
          ...filterParams,
          dateSelector,
        });
        return;
      default:
        break;
    }

    if (dateSelector === filterParams.dateSelector) {
      return;
    }

    setFilterParams({
      ...filterParams,
      dateSelector,
      startDate,
      endDate,
    });
    setFilterParams((prevState) => {
      onChange(prevState);
      return prevState;
    });
  };
  const menuLabel = filterParams.dateSelector !== CUSTOM_DATE_OPTION
    ? filterParams.dateSelector.label
    : `${filterParams.startDate.format(DATE_FORMAT_SLASHES)} - ${filterParams.endDate.format(DATE_FORMAT_SLASHES)}`;


  return showDatePicker ? (
    <DateRangePicker
      onChange={handleDateChange}
      onClose={handleOnCloseDateRange}
      minDate={null}
      maxDate={moment()}
      anchorDirection={ANCHOR_LEFT}
      startDate={filterParams.startDate}
      endDate={filterParams.endDate}
      focusOnMounted
    />
  ) : (
    <>
      <Button
        // className={classNames(classes.DateRangePicker, { open: anchorEl })}
        onClick={handleMenuClick}
        size="large"
        startIcon={<Calendar viewBox="0 0 22 22" />}
        variant="outlinedWhite"
      >
        { menuLabel }
      </Button>
      <Menu
        id="daterange-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {DATE_OPTIONS.map(option => (
          <MenuItem onClick={() => handleDateChangeFilter(option)}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

const styles = theme => ({
  ...getFilterStyle(theme),
});

DateTimeWithRangeFilter.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func,
  value: PropTypes.shape({
    dateSelector: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
  }),
};

DateTimeWithRangeFilter.defaultProps = {
  onChange: () => {},
  value: {
    dateSelector: LAST_MONTH_DATE_OPTION,
    startDate: moment().subtract(30, 'd').local(),
    endDate: moment().local(),
  },
};

export default withStyles(styles)(DateTimeWithRangeFilter);
